import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cureentAttendence: {},
};

const payrollSlice = createSlice({
  name: "payroll",
  initialState,
  reducers: {
    setCurruntAttendance: (state, action) => {
      state.cureentAttendence = action.payload;
    },
  },
});

export const { setCurruntAttendance,setMetrics } = payrollSlice.actions;
export default payrollSlice.reducer;
